import { getAttributionContextLabel } from "./attribution-context-kind";

export const formatActorWithContext = (params: {
  actorName: string;
  contextKind: string | null | undefined;
}): string => {
  const label = getAttributionContextLabel(params.contextKind);
  return label ? `${params.actorName} via ${label}` : params.actorName;
};
